import { beginAjaxCall } from './ajaxStatusActions';
import { AxiosRequestConfig, AxiosResponse } from 'axios';
import API from '../constants/apiEndpoints';
import { msalFetch } from '../components/auth/Auth-Utils';
import { toastr } from 'react-redux-toastr';

import * as types from './actionTypes';
import { constants } from '../constants/constants';
import { IDocumentType, ThunkResult } from '../models';

export function getDocumentTypes(): ThunkResult<any> {
    return (dispatch, getState) => {
        dispatch(beginAjaxCall());
        const axiosOptions: AxiosRequestConfig = {
            method: 'get'
        };
        const url = API.cloudDocument.getAll;
        return msalFetch(url, axiosOptions)
            .then((data: AxiosResponse<any>) => {
                if (!data.data) {
                    throw new Error('missing data');
                } else {
                    dispatch({
                        type: types.LOAD_DOCUMENT_TYPES_SUCCESS,
                        payload: data.data
                    });
                    return data;
                }
            })
            .catch((error: any) => {
                dispatch({
                    type: types.LOAD_DOCUMENT_TYPES_FAILED,
                    error,
                    axiosOptions
                });
                constants.handleError(error, 'get Document Types');
                console.error(error);
            });
    };
}

export function saveDocumentTypes(
    documentType: IDocumentType
): ThunkResult<any> {
    return (dispatch, getState) => {
        dispatch(beginAjaxCall());

        const axiosOptions: AxiosRequestConfig = {
            method: 'post',
            data: {
                name: documentType.name
            }
        };

        const url = API.cloudDocument.documentType;
        return msalFetch(url, axiosOptions)
            .then((data: AxiosResponse<any>) => {
                const newType = {
                    id: data.data.value.id,
                    name: documentType.name
                };

                dispatch({
                    type: types.ADD_DOCUMENT_TYPES_SUCCESS,
                    payload: newType
                });

                dispatch({
                    type: types.SET_SELECTED_DOCUMENT_TYPE_ID,
                    id: newType.id
                });

                toastr.success(
                    'Success',
                    `Created Document Type`,
                    constants.toastrSuccess
                );
            })
            .catch((error: any) => {
                dispatch({
                    type: types.ADD_DOCUMENT_TYPES_FAILED,
                    error,
                    axiosOptions
                });
                constants.handleError(error, 'create document type');
                console.error(error);
            });
    };
}

export function updateDocumentType(
    documentType: IDocumentType
): ThunkResult<any> {
    return (dispatch, getState) => {
        dispatch(beginAjaxCall());

        const axiosOptions: AxiosRequestConfig = {
            method: 'put',
            data: {
                name: documentType.name
            }
        };

        const url = `${API.cloudDocument.documentType}/${documentType.id}`;
        return msalFetch(url, axiosOptions)
            .then((data: AxiosResponse<any>) => {
                const updatedType = data.data;

                dispatch({
                    type: types.EDIT_DOCUMENT_TYPE_SUCCESS,
                    payload: updatedType
                });
                toastr.success(
                    'Success',
                    `Updated Document Type.`,
                    constants.toastrSuccess
                );
            })
            .catch((error: any) => {
                dispatch({
                    type: types.EDIT_DOCUMENT_TYPE_FAILED,
                    error,
                    axiosOptions
                });
                constants.handleError(error, 'update document type');
                console.error(error);
            });
    };
}

export function deleteDocumentType(documentTypeID: string): ThunkResult<any> {
    return (dispatch, getState) => {
        dispatch(beginAjaxCall());

        const axiosOptions: AxiosRequestConfig = {
            method: 'delete'
        };

        const url =
            API.cloudDocument.documentType + '/' + documentTypeID.toString();
        return msalFetch(url, axiosOptions)
            .then((data: AxiosResponse<any>) => {
                dispatch({
                    type: types.DELETE_DOCUMENT_TYPE_SUCCESS,
                    payload: documentTypeID
                });
                toastr.success(
                    'Success',
                    `Deleted Document Type.`,
                    constants.toastrSuccess
                );
            })
            .catch((error: any) => {
                dispatch({
                    type: types.DELETE_DOCUMENT_TYPE_FAILED,
                    error,
                    axiosOptions
                });
                constants.handleError(error, 'delete document type');
                console.error(error);
            });
    };
}

export const toggleEditDocumentTypeModal = () => ({
    type: types.TOGGLE_MODAL_EDIT_DOCUMENT_TYPE
});

export const setSelectedDocumentTypeID = (id: string) => ({
    type: types.SET_SELECTED_DOCUMENT_TYPE_ID,
    id
});

export const clearSelectedDocumentTypeID = () => ({
    type: types.CLEAR_SELECTED_DOCUMENT_TYPE_ID
});
